import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const AMENITY_LABELS = {
  "MS Word/Office": "MS Office",
  "AI tools": "AI Tools",
  "printer": "Printer",
  "dual monitor": "Dual Monitor",
  "fast wifi": "Fast Wi-Fi",
  "quiet room": "Quiet Room",
  "ergonomic chair": "Ergonomic Chair",
};
